import http from "../http";

export async function getPartnerHosted(epId) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.get("/sftp/partner-hosted/settings", config);
  return response.data;
}

export async function updatePartnerHosted(epId, data) {
  const config = {
    params: { epId: epId }
  };
  const response = await http.put("/sftp/partner-hosted/settings", data, config);
  return response.data;
}

export async function getMarkaazHosted(epId) {
  const config = {
    params: { epId: epId }
  };

  const response = await http.get("/sftp/markaaz-hosted/settings", config);
  return response.data;
}

export async function updateMarkaazHosted(data) {
  const response = await http.post("/sftp/markaaz-hosted/settings", data);
  return response.data;
}

export async function runTestConnection(epId) {
  const response = await http.post("/sftp/partner-hosted/test-connection", epId);
  return response.data;
}
